import { isInView } from './utils';

const scrollCart = {
  cartLine: document.getElementById('addToCartLine'),
  cartBtn: document.querySelectorAll('.jsInView') as NodeListOf<HTMLElement> | null,

  init() {
    window.addEventListener('DOMContentLoaded', this.setScroll.bind(this));
    window.addEventListener('scroll', this.setScroll.bind(this));
  },

  setScroll() {
    if (!this.cartBtn || !this.cartLine) return;

    const anyInView = Array.from(this.cartBtn).some(btn => isInView(btn));

    if (anyInView) {
      this.cartLine.classList.add('activeClass');
    } else {
      this.cartLine.classList.remove('activeClass');
    }
  },
};

export default scrollCart;